import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import svgChevron from '@img/icons/background/chevron-down.svg?url';
import styled, { css } from 'styled-components';
import { CommonTextInputStyles } from '../Textbox/Textbox.styles';
export const CommonSelectStyles = css `
  ${CommonTextInputStyles};
`;
export const CommonDropdownWrapperStyles = css `
  --translateY: -50%;

  position: relative;

  &::after {
    ${transition('transform')};

    content: '';
    display: inline-flex;
    align-items: center;
    width: 14px;
    height: 14px;
    position: absolute;
    top: 50%;
    right: 20px;
    background-color: ${brand.global.white};
    background-image: url(${svgChevron});
    background-repeat: no-repeat;
    transform: translateY(var(--translateY));
    pointer-events: none;
    background-size: contain;
  }

  &:focus-within::after {
    transform: translateY(var(--translateY)) rotate(180deg);
  }
`;
const Wrapper = styled.div `
  ${CommonDropdownWrapperStyles};
`;
const Select = styled.select `
  ${CommonSelectStyles};
`;
const SelectStyles = {
    Wrapper,
    Select,
};
export default SelectStyles;
